import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/shared/stores/auth';
import { employeeRoutes } from '@/areas/employee/routes';
import { customerRoutes } from '@/areas/customer/routes';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login.vue'),
    meta: {public: true},
  },
  {
    path: '/',
    name: 'home',
    redirect: () => {
      const auth = useAuthStore();
      if (!auth.isAuthenticated) return {name: 'login'};
      return auth.userType === 'EMPLOYEE_PORTAL_USER' ? {name: 'employee-home'} : {name: 'customer-home'};
    },
  },
  employeeRoutes,
  customerRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/pages/NotFound.vue'),
    meta: {public: true},
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  const isPublic = to.matched.some((r) => r.meta.public);

  if (!isPublic && !auth.isAuthenticated) {
    return {name: 'login', query: {redirect: to.fullPath}};
  }

  const required = to.matched.find((r) => r.meta.userType)?.meta.userType as
    | 'EMPLOYEE_PORTAL_USER'
    | 'CUSTOMER_PORTAL_USER'
    | undefined;

  if (required && auth.userType !== required) {
    return auth.userType === 'EMPLOYEE_PORTAL_USER' ? {name: 'employee-home'} : {name: 'customer-home'};
  }

  return true;
});
